import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk to CreateCategory category
export const CreateCategory = createAsyncThunk(
  "categories/createCategory",
  async ({ formData, categoryType }, { rejectWithValue }) => {
    try {
      const validCategoryTypes = ["quantity", "package", "stock"];
      if (!validCategoryTypes.includes(categoryType)) {
        return rejectWithValue("Invalid category type");
      }

      let endpoint;
      switch (categoryType) {
        case "quantity":
          endpoint = `/Categories/Create/`;
          break;
        case "package":
          endpoint = `/PackageCategories/`;
          break;
        case "stock":
          endpoint = `/ProductVouchers/`;
          break;
        default:
          return rejectWithValue("Invalid category type");
      }

      const response = await axios.post(`${apiUrl}${endpoint}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      return response.data; // Data returned from the API
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    isLoading: false,
    error: null,
    updatedCategory: null, // Store the updated category data
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CreateCategory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(CreateCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updatedCategory = action.payload;
        state.error = null;
      })
      .addCase(CreateCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default categoriesSlice.reducer;
